import { useModeAwareQuery } from "./useModeAwareQuery";
import { useApi } from "./useApi";
import type { CurrencyApi } from "@/types/api/companies";

/**
 * Mock currencies data for demo mode
 */
const mockCurrencies: CurrencyApi[] = [
  { id: 1, code: 'USD', name: 'US Dollar', symbol: '$' },
  { id: 2, code: 'EUR', name: 'Euro', symbol: '€' },
  { id: 3, code: 'GBP', name: 'British Pound', symbol: '£' },
  { id: 4, code: 'CAD', name: 'Canadian Dollar', symbol: 'CA$' },
  { id: 5, code: 'AUD', name: 'Australian Dollar', symbol: 'A$' },
  { id: 6, code: 'JPY', name: 'Japanese Yen', symbol: '¥' },
  { id: 7, code: 'CHF', name: 'Swiss Franc', symbol: 'CHF' },
];

/**
 * Hook to fetch currencies list
 * Respects demo/live mode - uses mock data in demo mode, API in live mode
 */
export function useCurrenciesList() {
  const { apiGet } = useApi();

  return useModeAwareQuery<CurrencyApi[], Error>(
    ["currencies"],
    async ({ signal }) => {
      const response = await apiGet<CurrencyApi[]>("/api/v1/currencies", undefined, signal);
      return response;
    },
    mockCurrencies,
    {
      staleTime: 5 * 60 * 1000, // 5 minutes - currencies don't change often
    }
  );
}
